export enum ChecklistDocumentFilter {
  All = 'all',
  RequiredMissing = 'requiredMissing',
  ReviewMissing = 'reviewMissing',
  Verified = 'verified',
}
